import { Link } from "react-router-dom";
import { useLanguage } from '../../context/LanguageContext';
import { valouseTranslations } from '../../translations/valouseTranslations';

const CircleSection = () => {
  const { language } = useLanguage();
  const t = (obj) => obj[language] || obj['fr'];
  const tr = valouseTranslations;

  return (
    <section id="cercle" className="py-20 sm:py-28 px-6 bg-[#8d7a6b]">
      <div className="max-w-2xl mx-auto text-center text-[#F3E5CF]">

        {/* Context + Title */}
        <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#3F2A24] mb-3">
          {t(tr.circle.contextLine)}
        </p>
        <h2
          className="font-serif text-2xl sm:text-3xl md:text-4xl text-[#F3E5CF] mb-4"
          style={{ textWrap: 'balance' }}
        >
          {t(tr.circle.title)}
        </h2>
        <p className="font-serif text-sm sm:text-base text-[#F3E5CF]/70 italic mb-10">
          {t(tr.circle.poeticLine)}
        </p>

        <div className="w-16 h-[1px] bg-[#3F2A24]/50 mx-auto mb-12" />

        {/* Stanza 1 */}
        <div className="space-y-3 text-base sm:text-lg leading-[2.2] font-serif">
          <p>{t(tr.circle.circleIntro)}</p>
          <p className="text-[#F3E5CF]/70">{t(tr.circle.circleNotAddition)}</p>
        </div>

        <div className="w-8 h-[1px] bg-[#3F2A24]/30 mx-auto my-10 sm:my-14" />

        {/* Stanza 2 */}
        <div className="space-y-3 text-base sm:text-lg leading-[2.2] font-serif">
          <p className="font-medium">{t(tr.circle.womenCount)}</p>
          <p className="text-[#F3E5CF]/80">{t(tr.circle.womenPresent)}</p>
          <p className="text-[#F3E5CF]/80">{t(tr.circle.womenAnchored)}</p>
          <p className="text-[#F3E5CF]/80">{t(tr.circle.womenComplementary)}</p>
        </div>

        <div className="w-8 h-[1px] bg-[#3F2A24]/30 mx-auto my-10 sm:my-14" />

        {/* Stanza 3 */}
        <div className="space-y-3 text-base sm:text-lg leading-[2.2] font-serif">
          <p>{t(tr.circle.weaveLine1)}</p>
          <p className="italic">{t(tr.circle.weaveLine2)}</p>
        </div>

        {/* CTA */}
        <div className="mt-14">
          <Link
            to="/coconeuses"
            className="inline-flex items-center justify-center px-8 py-3 rounded-full bg-[#F3E5CF] text-[#3F2A24] text-xs tracking-[0.2em] uppercase hover:bg-[#9E9590] hover:text-white transition-colors min-h-[48px]"
            data-testid="discover-coconeuses-btn"
          >
            Je rencontre les coconeuses
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CircleSection;
